import React,{ useState } from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import {  useHistory } from 'react-router-dom';

// Components
import Loading from '../components/Loading';
import FormErrors, { trowError } from '../components/FormErrors';
import AcreditacionProfile from '../models/AcreditacionProfile';
import { LIST_EVENTS } from '../models/Eventos';


const moment = require('moment-timezone').tz.setDefault('America/Mexico_City')
moment.locale('es');

const StyledPage = styled.main`
  display: flex;
  align-items:center;
  justify-content:center;
  flex-wrap:wrap;
  height: 100%;
  max-width:800px;
  width:100%;
  margin:0 auto;

`


const Tabla=styled.div`
.table-nth tr:nth-child(2n) {
        background-color: #DEDEDE;
    }
 th{
  background:var(--color-rojo);
  color:#ffffff;
  text-align:center;
  padding:10px 15px;
 }
 td{
  color:var(--color-azul);
  text-align:center;
  padding:10px 15px;
 }
`;

const SubTitulo=styled.div`
width:100%;
margin-bottom:50px;
 h2{
  color:var(--color-azul);
 }
`;





export default  () => {
    let history = useHistory();
    let UserInfo=AcreditacionProfile.getProfile();

  
    const { loading, error, data } = useQuery(LIST_EVENTS,{
        variables:{
            first:100
        }
    });

    if(loading)
        return <Loading />

    return (
        <StyledPage>
            <SubTitulo>
                <h2>Eventos</h2>
            </SubTitulo>
            <Tabla>
                <table className="table-nth">
                    <tr>
                        <th>Evento</th>
                        <th>Fecha</th>
                        <th>Lugar</th>
                        <th>SOBRE EL EVENTO</th>
                        <th></th>
                 
                    </tr>
                    {data.listEvents.edge.map( (item) => (
                        <tr key={item.id}>
                            <td>{item.nombre}</td>
                            <td>{moment(item.fecha).format('D [de] MMMM [del] YYYY [a las] HH:mm')}</td>
                            <td>{item.lugar}</td>
                            <td>{item.alt}</td>
                            <td>
                                {item.is_req_register && <>
                                    <a href={`/evento/registro/${item.id}`}>Registrate</a>
                                </>}
                            </td>
                        </tr>
                    ))}
                </table>
            </Tabla>
          
        </StyledPage>
    )
}